module.exports = __webpack_public_path__ + "img/Langham-UI.5a6c584e.png";